import React from "react";
import { Container } from "../../SharedStyles/SharedStyles";
import { FooterCont, A } from "./Styles";

const Footer = () => {
  return (
    <Container>
      <FooterCont>
        <h2>Copyright © 2022.</h2>
      </FooterCont>
    </Container>
  );
};

export default Footer;
